<template>
	<div>
		<div>
			<el-dialog title="新增项目" :width="$store.state.width>$store.state.minwidth?'800px':($store.state.width-12+'px')" :visible.sync="outerVisible" :before-close="formClose">
				<div v-loading="$store.state.formload">
					<el-form :model="formxm" ref="formxm" :rules="xmrules" :label-width="$store.state.width>$store.state.minwidth?'80px':''">
						<el-form-item label="项目名称" prop="name">
							<el-input v-model="formxm.name" autocomplete="off" style="width: 100%;"></el-input>
						</el-form-item>
						<el-form-item label="项目简介" prop="desc">
							<el-input type="textarea" v-model="formxm.desc" style="width: 100%;"></el-input>
						</el-form-item>
					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button type="primary" @click="addxm()">下一步</el-button>
						<el-button @click="clearxm()">取 消</el-button>
					</div>
				</div>
			</el-dialog>
			<el-dialog class="neiqian-dia" :width="$store.state.width>$store.state.minwidth?'800px':($store.state.width-12+'px')" title="新增基地系统" :visible.sync="innerVisible" :before-close="formClose">
				<div v-loading="$store.state.formload">
					<el-form :model="formjd" ref="formjd" :rules="jdrules" :label-width="$store.state.width>$store.state.minwidth?'80px':''" v-loading="formload">
						<el-form-item label="基地名称" prop="name">
							<el-input v-model="formjd.name" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item label="系统图片" prop="img">
							<el-upload class="avatar-uploader" :action="config['apiurl'] + '/api/common/upload'" :show-file-list="false"
							 :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
								<img v-if="formjd.img" :src="config['apiurl'] + formjd.img" class="avatar border">
								<i v-else class="el-icon-plus avatar-uploader-icon border"></i>
							</el-upload>
						</el-form-item>
						<el-form-item label="地理位置" prop="location">
							<!-- <el-input v-model="formjd.location" autocomplete="off"></el-input> -->
							<el-cascader
							  ref="addC"
							  :options="$store.state.address"
							  v-model="formjd.location"
							  @visible-change="addlatlng('formjd','addC')"
							  :props="props"
							  class="width">
							</el-cascader>
						</el-form-item>
						<el-form-item label="详情描述" prop="miaoshu">
							<el-input v-model="formjd.miaoshu" autocomplete="off"></el-input>
						</el-form-item>
						<el-row>
							<el-col :span="12">
								<el-form-item label="Lng" prop="Lng">
									<el-input v-model.number="formjd.Lng" autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="Lat" prop="Lat">
									<el-input v-model.number="formjd.Lat" autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button type="primary" @click="addjd()">确定添加基地</el-button>
						<el-button @click="clearjd()">取 消</el-button>
					</div>
				</div>
			</el-dialog>
			<el-dialog class="neiqian-dia" :width="$store.state.width>$store.state.minwidth?'800px':($store.state.width-12+'px')" title="修改基地系统" :visible.sync="editVisible" :before-close="formClose">
				<div v-loading="$store.state.formload">
					<el-form :model="formjdedit" ref="formjdedit" :rules="jdrules" :label-width="$store.state.width>$store.state.minwidth?'80px':''" v-loading="formload">
						<el-form-item label="基地名称" prop="name">
							<el-input v-model="formjdedit.name" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item label="系统图片" prop="img">
							<el-upload class="avatar-uploader" :action="config['apiurl'] + '/api/common/upload'" :show-file-list="false"
							 :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload2">
								<img v-if="formjdedit.img" :src="config['apiurl'] + formjdedit.img" class="avatar border">
								<i v-else class="el-icon-plus avatar-uploader-icon border"></i>
							</el-upload>
						</el-form-item>
						<el-form-item label="地理位置" prop="location">
							<!-- <el-input v-model="formjd.location" autocomplete="off"></el-input> -->
							<el-cascader
							  placeholder="(未修改)"
							  ref="editC"
							  :options="$store.state.address"
							  v-model="formjdedit.location"
							  @visible-change="addlatlng('formjdedit','editC')"
							  :props="props"
							  class="width">
							</el-cascader>
						</el-form-item>
						<el-row>
							<el-col :span="12">
								<el-form-item label="Lng" prop="Lng">
									<el-input v-model.number="formjdedit.Lng" autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="Lat" prop="Lat">
									<el-input v-model.number="formjdedit.Lat" autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button type="primary" @click="editjd()">确定修改基地</el-button>
						<el-button @click="editVisible=false">取 消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
		<el-row>
			<el-col :md="14">
				<div class="bread">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item>项目总览</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<el-button type="primary" class="el-icon-plus ljs-addXM" @click="openxm()" :size="$store.state.width<$store.state.minwidth?'small':''">新增项目</el-button>
				<el-col :span="24" v-for="(d,index) in $store.state.main.project" :key="index">
					<el-row>
						<el-col :span="24" class="ljs-xz">
							<el-button type="primary" icon="el-icon-plus" @click="openjd(d.id)" :size="$store.state.width<$store.state.minwidth?'small':''"></el-button>
							<span>&nbsp;&nbsp;{{d.name}}({{d.projectCount.countQaedas}}个)</span>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-card shadow="hover" :body-style="{ padding: '0px', position: 'relative' }" class="bg-purple" v-for="(a,index) in d.qaedasList" :key="index">
								<el-row class="ljs-head">
									<el-col :title="a.name" class="ljs-ziti" :xs="18" :sm="18" :md="18" :lg="18" :xl="18" >{{a.name}}</el-col>
									<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
										<el-popover
										  placement="bottom"
										  width="60"
										  trigger="hover">
											<div>
												<el-button type="primary" size="mini" @click="openeditxm(a)" class="sm-btn1">编辑</el-button>
												<el-button type="danger" size="mini" @click="del(a.id,d)">删除</el-button>
											</div>
											<el-button class="sm-btn2" slot="reference" type="text" icon="el-icon-edit"></el-button>
										</el-popover>
									</el-col>
								</el-row>
								<div class="card-body">
									<el-row class="ljs-body">
										<el-col :span="10" class="ljs-beijing">
											<img class="ljs-index-pho" :src="config['apiurl'] + a.image" />
										</el-col>
										<el-col :span="9" :offset="1" class="dis-inbl">
											<p>摄像头数：</p>
											<p>终端总数：</p>
											<p>数据条数：</p>
										</el-col>
										<el-col :span="4" class="tex-ri">
											<p class="ljs-zi2" :title="a.qaedasCount.countVideo">{{a.qaedasCount.countVideo}}</p>
											<p class="ljs-zi2" :title="a.qaedasCount.countTerminal">{{a.qaedasCount.countTerminal}}</p>
											<p class="ljs-zi2" :title="a.qaedasCount.countDevicesData">{{convert(a.qaedasCount.countDevicesData)}}</p>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="24">
											<p class="ljs-diqu">{{a.address}}</p>
										</el-col>
									</el-row>
								</div>
								<div class="into">
									<el-col v-show="a.lot_system==1" :span="12+getnum(a)" class="into-rk" title="点击进入"><el-button :disabled="a.lot_system!=1" type="text" class="into-rk-b" @click="open(a,'/iot/terminal')">&gt;&gt;物联系统&lt;&lt;</el-button></el-col>
									<el-col v-show="a.video_system==1" :span="12+getnum(a)" class="into-rk" title="点击进入"><el-button :disabled="a.video_system!=1" type="text" class="into-rk-b" @click="open(a,'/video/show')">&gt;&gt;视频监控&lt;&lt;</el-button></el-col>
									<el-col v-show="a.production_system==1" :span="12+getnum(a)" class="into-rk" title="点击进入"><el-button :disabled="a.production_system!=1" type="text" class="into-rk-b" @click="open(a,'/production/record')">&gt;&gt;生产信息&lt;&lt;</el-button></el-col>
									<el-col v-show="a.trace_system==1" :span="12+getnum(a)" class="into-rk" title="点击进入"><el-button :disabled="a.trace_system!=1" type="text" class="into-rk-b" @click="open(a,'/traceability/retrospect')">&gt;&gt;追溯管理&lt;&lt;</el-button></el-col>
									<el-col v-show="a.irrigation_system==1" :span="12+getnum(a)" class="into-rk" title="点击进入"><el-button :disabled="a.irrigation_system!=1" type="text" class="into-rk-b" @click="open(a,'gg')">&gt;&gt;灌溉系统&lt;&lt;</el-button></el-col>
								</div>
							</el-card>
						</el-col>
					</el-row>
				</el-col>
			</el-col>
		</el-row>
	</div>
</template>
<script>
	let _this;
	export default {
		data() {
			return {
				myload: true,
				formload: false,
				outerVisible: false,
				innerVisible: false,
				editVisible: false,
				xmid: null,
				formxm: {
					name: '',
					desc: ''
				},
				xmrules: {
					name: [
						{ required: true, message: '请输入项目名',	 trigger: 'blur' },
						{ min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
					],
					desc: [
						{ required: true, message: '请输入项目简介', trigger: 'blur' }
					]
				},
				formjd: {
					name: '',
					img: '',
					location: [],
					jingweidu: '',
					miaoshu: '',
					Lng: null,
					Lat: null
				},
				jdrules: {
					name: [
						{ required: true, message: '请输入基地名',	 trigger: 'blur' },
						{ min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
					],
					img: [
						{ required: true, message: '请上传图片', trigger: 'blur' }
					],
					location:[
						{ required: true, message: '请选择地址', trigger: 'blur' }
					],
					miaoshu:[
						{ required: true, message: '请输入基地描述', trigger: 'blur' }
					],
					Lng: [
						{ required: true, message: '经度不能为空'},
						{ type: 'number', message: '经度必须为数字值'}
					],
					Lat: [
						{ required: true, message: '纬度不能为空'},
						{ type: 'number', message: '纬度必须为数字值'}
					]
				},
				formjdedit: {
					id: null,
					name: '',
					img: '',
					location: [],
					Lng: 0,
					Lat: 0
				},
				props: {
					checkStrictly: true,
					value: 'id',
					label: 'name',
					children: 'children',
					lazy: true,
					lazyLoad (node, resolve) {
						let val=node.path;
						_this.loadadr(val)
						.then((adr) => {
							resolve(adr);
						});
					}
				}
			}
		},
		mounted: function () {
			_this=this;
			this.load();
		},
		methods: {
			handleAvatarSuccess(res, file) {
				this.formjd.img = res.data.url;
			},
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isLt2M;
			},
			handleAvatarSuccess2(res, file) {
				this.formjdedit.img = res.data.url;
			},
			beforeAvatarUpload2(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isLt2M;
			},
			del(id,d) {
				this.$confirm('此操作将永久删除该基地，并且删除最后一个基地时将把项目删除，是否继续？', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
				.then(() => {
					let value={
						id: id
					};
					this.delqaedas(value);
					if(d.projectCount.countQaedas==1)
					{
						let pro={
							id: d.id
						};
						this.delproject(pro);
					}
				})
			},
			load()
			{
				this.$store.commit('mainload',true);
				this.getproject()
				.then(()=>{
					this.$store.commit('mainload',false);
				});
			},
			openxm()
			{
				this.outerVisible = true;
				this.$nextTick(()=>{
                    this.$refs['formxm'].resetFields();
                })
			},
			clearxm()
			{
				this.outerVisible = false;
				this.$nextTick(()=>{
					this.$refs['formxm'].resetFields();
					})
			},
			addxm()
			{
				this.$refs['formxm'].validate((valid) => {
					if(valid)
					{
						this.innerVisible = true;
						this.$nextTick(()=>{
							this.$refs['formjd'].resetFields();
						})
					}
				})
			},
			openjd(id)
			{
				this.$nextTick(()=>{
					this.innerVisible = true;
					this.xmid=id;
					this.$refs['formjd'].resetFields();
					this.$refs['formxm'].resetFields();
				})
			},
			clearjd()
			{
				this.innerVisible = false;
				this.outerVisible = false;
			},
			addjd()
			{
				this.$refs['formjd'].validate((valid) => {
					if(valid)
					{
						this.$store.commit('formload',true);
						this.formload=true;
						this.innerVisible = false;
						this.outerVisible = false;
						if(this.formxm.name!="")
						{
							let value={
								name: this.formxm.name,
								content: this.formxm.desc
							};
							this.addproject(value)
							.then((response)=>{
								if(response.data.code==1)
								{
									this.xmid=response.data.data;
									this.addjda();
								}
								else
								{
									this.$store.commit('formload',false);
								}
							});
						}
						else
						{
							this.addjda();
						}
					}
				});
			},
			addjda()
			{
				let value={
					project_id: this.xmid,
					name: this.formjd.name,
					image: this.formjd.img,
					address: this.adrtrans(this.formjd.location),
					latlong: this.formjd.Lat+","+this.formjd.Lng,
					content: this.formjd.miaoshu
				}
				this.addqaedas(value)
				.then((response)=>{
					if(response.data.code==1)
					{
						this.outerVisible=false;
						this.innerVisible=false;
					}
					this.$store.commit('formload',false);
				});
			},
			openeditxm(item)
			{
				this.editVisible = true;
				this.$nextTick(()=>{
					this.$refs['formjdedit'].resetFields();
					this.formjdedit.id=item.id;
					this.formjdedit.name=item.name;
					this.formjdedit.img=item.image;
					var city=item.city.split(',');
					// this.getProvince(false).then(()=>{
					// 	this.getCity(false,city).then(()=>{
					// 		this.getCounty(false,city).then(()=>{
					// 			this.getVillage(false,city).then(()=>{
					// 				this.getTown(true,city).then(()=>{
					// 					for(var i=0;i<city.length;i++)
					// 					{
					// 						this.formjdedit.location.push(Number(city[i]));
					// 					}
					// 				})
					// 			})
					// 		})
					// 	})
					// })
					this.formjdedit.Lng=Number(item.latlong.split(',')[1]);
					this.formjdedit.Lat=Number(item.latlong.split(',')[0]);
				})
			},
			editjd()
			{
				this.$refs['formjdedit'].validate((valid) => {
					if(valid)
					{
						this.$store.commit('formload',true);
						let value={
							id: this.formjdedit.id,
							name: this.formjdedit.name,
							image: this.formjdedit.img,
							city: this.adrtrans(this.formjdedit.location),
							latlong: this.formjdedit.Lat+","+this.formjdedit.Lng
						};
						this.editqaedas(value)
						.then((response)=>{
							if(response.data.code==1)
							{
								this.editVisible=false;
							}
							this.$store.commit('formload',false);
						});
					}
				});
			},
			open(Qaedas,url)
			{
				if(url=='gg')
				{
					window.open("https://gg.farmereasy.com/home?token="+this.getCookie(this.config.token)+"&jdid="+Qaedas.id);
					return;
				}
				this.setCookie(this.config.jdid,Qaedas.id,3);
				this.$router.push(url);
			},
			convert(num)
			{
				var mynum=0;
				if(num>10000)
				{
					mynum=num/10000;
					return mynum.toFixed(1)+"万";
				}
				else
				{
					return num;
				}
			},
			addlatlng(form,control)
			{
				let adr = this.$refs[control].presentText;
				let _this=this;
				if(adr==null)
				{
					return;
				}
				// 创建地址解析器实例
				var myGeo = new BMap.Geocoder();
				myGeo.getPoint(adr, function(point){
					if (point) {
						_this[form].Lng=point.lng;
						_this[form].Lat=point.lat;
					}else{
						_this.$message({
							message: "解析错误!",
							type: 'error',
							center: true,
						});
					}
				});
			},
			getnum(item)
			{
				let length=0;
				length+=item.lot_system==1?1:0;
				length+=item.video_system==1?1:0;
				length+=item.production_system==1?1:0;
				length+=item.trace_system==1?1:0;
				length+=item.irrigation_system==1?1:0;
				return length>2?0:12;
			}
		}
	}
</script>

<style scoped>
	.dialog-footer{
		text-align: center;
	}
	.bread{
		height: 14px;
		padding: 8px 0;
	}
	.ljs-zi1{
		font-size:22px;
	}
	.ljs-zi2{
		font-size:15px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.card-body{
		height: 117px;
	}
	.ljs-body{
		padding: 6px 0px 6px 6px;
	}
	.ljs-index-pho{
		border-radius:50%;
		width: 90px;
		height: 90px;
		box-shadow: darkgrey 0px 0px 8px 1px inset;
	}
	.ljs-xz{
		margin-top: 0px;
	}
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	.border{
		border: 1px solid #dcdfe6;
		border-radius:4px;
	}
	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 78px;
		height: 78px;
		line-height: 78px;
		text-align: center;
	}
	.avatar {
		width: 78px;
		height: 78px;
		display: block;
	}
	.ljs-mp {
		margin-top: 10px;
		padding-left: 20px;
		padding-top: 20px;
		/* position: absolute; */
	}

	.el-form-item__content {
		line-height: 0 !important;
	}

	.bg-purple{
		/* background: #d3dce6; */
		width: 100%;
		max-width: 280px;
		/* border-radius: 4px;
		min-height: 36px;
		height: 180px;
		margin-right: 20px;
		margin-bottom: 20px;
		border: 1px solid #d3dce6;
		background-color: white; */
		margin-top: 20px; 
		float: left;
		margin-right: 20px;
		height: 180px;
	}

	.no-back {
		width: 100%;
		margin-right: 0;
	}

	.bg-none {
		background-color: #FFFFFF;
	}

	.sm-btn1 {
		margin-right: 7px;
		margin-left: 7px;
		/* margin-left: 5px; */
	}
	.sm-btn2 {
		width: 24px;
		height: 20px;
		padding: 0;
		color: white;
		float: right;
		margin-right: 5px;
		/* margin-left: 5px; */
	}

	.ljs-head {
		background: #6f7e95;
		padding: 4px;
		height:30px;
		border-radius: 4px 4px 0 0;
	}

	.ljs-beijing {
		text-align: center;
	}
	.ljs-beijing img {
		width: 100px;
		height: 100px;
		border-radius: 50%
	}

	.dis-inbl {
		line-height: 28px;
		text-align: right;
		position: relative;
		top: 10px;
	}

	.tex-ri {
		line-height: 28px;
		text-align: left;
		position: relative;
		top: 10px;
	}

	.ljs-addXM {
		position: absolute;
		top: 0px;
		right: 0px;
		z-index: 10;
	}

	.el-textarea {
		display: inline-block;
		width: 75%;
		vertical-align: bottom;
		font-size: 14px;

	}

	.el-textarea__inner {
		min-height: 100px !important;
	}

	.el-input {
		position: relative;
		font-size: 14px;
		display: inline-block;
		width: 50%;
	}
	.el-cascader {
    display: inline-block;
    position: relative;
    font-size: 14px;
    line-height: 40px;
    width: 100%;
}

	.el-dialog__body {
		padding: 30px 20px 0px 20px;
		color: #606266;
		font-size: 14px;
	}

	.neiqian-dia .el-input {
		position: relative;
		font-size: 14px;
		display: inline-block;
		width: 100%;
	}

	.ljs-diqu {
		font-size: 16px;
		font-weight: 600;
		text-align: center;
		border-top:1px solid rgb(91,155,213) ;
		padding: 4px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
 
	.ljs-ziti {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		color: #F8F8FF;
		text-align: center;
		font-size:16px;
	}
	.center{
		text-align: center;
	}
	.width{
		width: 100%;
	}
	.into{
		position: absolute;
		/* display: none; */
		height: 0px;
		width: 100%;
		background-color: rgba(0,0,0,0.7);
		bottom: -32px;
		transition: height 0.5s;
		-moz-transition: height 0.5s;	/* Firefox 4 */
		-webkit-transition: height 0.5s;	/* Safari 和 Chrome */
		-o-transition: height 0.5s;	/* Opera */
	}
	.el-card__body:hover .into{
		height: 149px;
		/* display: block; */
	}
	.into-rk{
		text-align: center;
		height: 73px;
		padding-top: 18px;
	}
	.into-rk-b{
		color: white;
	}
	.into-rk-b:hover{
		border: 1px solid white;
		padding: 15px 10px;
	}
	p{
		margin: 0;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.el-main{
			padding: 0px;
		}
		.bg-purple{
			width: 99%;
			margin: auto;
			margin-top: 10px;
			max-width: none;
		}
	}
</style>
